module.exports = __webpack_public_path__ + "static/media/bioPin.962ec204.png";